import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import clsx from "clsx";

const EditForm = ({ classes, RestData, setRestData }) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12}>
          <Grid container className={clsx(classes.dFlex, classes.mb20)}>
            <Grid item xs={4} md={4}>
              <Typography variant="body1">Restaurant Name :</Typography>
            </Grid>
            <Grid item xs={8} md={8}>
              <TextField
                label="Restaurant name"
                type="text"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
                value={RestData.restName}
                size="small"
                // onChange={(e) =>
                //   setRestData({
                //     ...RestData,
                //     restName: e.target.value,
                //   })
                // }
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container className={clsx(classes.dFlex, classes.mb20)}>
            <Grid item xs={4} md={4}>
              <Typography variant="body1">Owner/Manager Name :</Typography>
            </Grid>
            <Grid item xs={8} md={8}>
              <TextField
                label="Owner name"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
                value={RestData.ownerName}
                size="small"
                // onChange={(e) =>
                //   setRestData({
                //     ...RestData,
                //     ownerName: e.target.value,
                //   })
                // }
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container className={clsx(classes.dFlex, classes.mb20)}>
            <Grid item xs={4} md={4}>
              <Typography variant="body1">State :</Typography>
            </Grid>
            <Grid item xs={8} md={8}>
              <TextField
                label="State"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                value={RestData.state}
                // onChange={(e) =>
                //   setRestData({
                //     ...RestData,
                //     state: e.target.value,
                //   })
                // }
                fullWidth
                size="small"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container className={clsx(classes.dFlex, classes.mb20)}>
            <Grid item xs={4} md={4}>
              <Typography variant="body1">City :</Typography>
            </Grid>
            <Grid item xs={8} md={8}>
              <TextField
                label="City"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                value={RestData.city}
                // onChange={(e) =>
                //   setRestData({
                //     ...RestData,
                //     city: e.target.value,
                //   })
                // }
                fullWidth
                size="small"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container className={clsx(classes.dFlex, classes.mb20)}>
            <Grid item xs={4} md={4}>
              <Typography variant="body1">Email :</Typography>
            </Grid>
            <Grid item xs={8} md={8}>
              <TextField
                label="Email"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                value={RestData.email}
                // onChange={(e) =>
                //   setRestData({
                //     ...RestData,
                //     email: e.target.value,
                //   })
                // }
                fullWidth
                size="small"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container className={clsx(classes.dFlex, classes.mb20)}>
            <Grid item xs={4} md={4}>
              <Typography variant="body1">Phone No :</Typography>
            </Grid>
            <Grid item xs={8} md={8}>
              <TextField
                label="Contact number"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                value={RestData.contactNumber}
                // onChange={(e) =>
                //   setRestData({
                //     ...RestData,
                //     contactNumber: e.target.value,
                //   })
                // }
                fullWidth
                size="small"
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EditForm;
